/**
 *
 */
export var HierarchicalProperty;
(function (HierarchicalProperty) {
    /**
     *
     */
    HierarchicalProperty[HierarchicalProperty["MOUSE_ENABLED"] = 1] = "MOUSE_ENABLED";
    /**
     *
     */
    HierarchicalProperty[HierarchicalProperty["VISIBLE"] = 2] = "VISIBLE";
    /**
     *
     */
    HierarchicalProperty[HierarchicalProperty["MASK_ID"] = 4] = "MASK_ID";
    /**
     *
     */
    HierarchicalProperty[HierarchicalProperty["MASKS"] = 8] = "MASKS";
    /**
     *
     */
    HierarchicalProperty[HierarchicalProperty["COLOR_TRANSFORM"] = 16] = "COLOR_TRANSFORM";
    /**
     *
     */
    HierarchicalProperty[HierarchicalProperty["SCENE_TRANSFORM"] = 32] = "SCENE_TRANSFORM";
    /**
     *
     */
    HierarchicalProperty[HierarchicalProperty["SCALE9"] = 64] = "SCALE9";
    /**
     *
     */
    HierarchicalProperty[HierarchicalProperty["ROOT"] = 128] = "ROOT";
    /**
     *
     */
    HierarchicalProperty[HierarchicalProperty["ALL"] = 255] = "ALL";
})(HierarchicalProperty || (HierarchicalProperty = {}));
